import api from "../api"
import moment from 'moment'

export default {
    data(){
        return {
            taskTypes: [
                "Timebasert",
                "Fastpris",
                "Supportavtale",
                "GuruLabs",
                "Ikke-fakturerbar",
                "Uavklart",
                "Ukjent"
            ],
            tasks: localStorage.getItem('tasks') ? JSON.parse(localStorage.getItem('tasks')) : {},
            folders: localStorage.getItem('folders') ? JSON.parse(localStorage.getItem('folders')) : {},
        }
    },
    methods:{
        getTaskColor: function(id){
            let type = this.getTaskType(id)
            if(type == "Timebasert") return 'success'
            if(type == "Fastpris") return 'info'
            if(type == "Supportavtale") return 'info'
            if(type == "GuruLabs") return 'info'
            if(type == "Ikke-fakturerbar") return 'warning'
            if(type == "Uavklart") return 'error'
            if(type == "Ukjent") return 'accent'
            return 'accent' // ukjent
        },
        getTaskType: function (id){
            let task = this.getTask(id)
            if(!task || !task.customFields) return null
            let type = this.getTask(id).customFields.filter(i => i.id == "IEAARZFPJUAAA6YZ").map(i => i.value)
            if(Array.isArray(type)) type = type[0]
            if(!type || type == "") return "Ukjent"
            return type
        },
        getTask: function (id){
            return this.tasks[id] || {}
        },
        async fetchTasks(taskIds){
            if(taskIds.length > 0){
                let url = "/tasks/" + taskIds.join(",")
                let data = await api.GET(url)
                this.storeTasks(data)
            }
        },
        storeTasks(data){
            for(let i in data.data){
                let element = data.data[i]
                element.loaded = data.loaded
                this.$set(this.tasks, element.id, element)
            }
            localStorage.setItem('tasks', JSON.stringify(this.tasks))
        },
        isTaskTimeout(entity){
            if(!entity.loaded) return true
            if(moment(entity.loaded, "DD.MM.YYYY HH:mm:ss").diff(moment(), 'hour') > 12) return true
            return false
        },
        getMissingTasks(timelogs, refresh){
            let allTaskIds = []
            let missingTasks = []
            let tasksToFetch = []
            let promises = []
            for(let t in timelogs){
                let timelog = timelogs[t]
                allTaskIds.push(timelog.taskId)
                let task = this.tasks[timelog.taskId]
                // if we dont have task from before, or we want to force refresh of it or timeout
                if(!task || refresh || this.isTaskTimeout(task)){
                    // check that we did not already ordered a fetch for it.
                    if(missingTasks.indexOf(timelog.taskId) === -1) {
                        missingTasks.push(timelog.taskId)
                        tasksToFetch.push(timelog.taskId)
        
                        if(tasksToFetch.length > 99){
                            promises.push(this.fetchTasks(tasksToFetch, refresh))
                            tasksToFetch = []
                        }
                    }
                }
            }
            if(tasksToFetch.length > 0) promises.push(this.fetchTasks(tasksToFetch, refresh))
            //wait for all tasks to be fetched, then get folders.
            Promise.allSettled(promises).then(() => this.getMissingFolders(allTaskIds, refresh))
        },
        getFolder: function(id){
            if(["IEAARZFPI7777777"].indexOf(id) > -1) return {title:'Hovedmappe'}
            return this.folders[id] || {}
        },
        async fetchFolders(ids){
            if(ids.length > 0){
                let url = "/folders/" + ids.join(",")
                let data = await api.GET(url)
                for(let i in data.data){
                    let element = data.data[i]
                    element.loaded = data.loaded
                    this.$set(this.folders, element.id, element)
                }
                localStorage.setItem('folders', JSON.stringify(this.folders))
            }
        },
        isFolderTimeout(entity){
            if(!entity.loaded) return true
            if(moment(entity.loaded, "DD.MM.YYYY HH:mm:ss").diff(moment(), 'hour') > 48) return true
            return false
        },
        getMissingFolders(taskIds, refresh){
            let missingFolderIds = []
            let foldersToFetch = []
            for(let t in taskIds){
                let task = this.getTask(taskIds[t])
                if(task){
                    let folderIds = task.parentIds.concat(task.superParentIds)
                    for(let f in folderIds){
                        let folderId = folderIds[f]
                        if(["IEAARZFPI7777777"].indexOf(folderId) > -1) continue;
                        
                        let folder = this.getFolder(folderId)
                        if(!folder || refresh || this.isFolderTimeout(folder)){
                            if(missingFolderIds.indexOf(folderId) === -1){
                                missingFolderIds.push(folderId)
                                foldersToFetch.push(folderId)
                                
                                if(foldersToFetch.length > 99){
                                    this.fetchFolders(foldersToFetch, refresh)
                                    foldersToFetch = []
                                }
                            }
                        }
                    }
                }
            }
            if(foldersToFetch.length > 0) this.fetchFolders(foldersToFetch, refresh)
        },
    }
}